import { isSameDay } from 'date-fns';
export const noop = () => { };
function collectCalendarButtons(parentNode) {
    const dayButtonSelector = 'button[data-calendar-day]';
    const buttons = parentNode.querySelectorAll(dayButtonSelector);
    return buttons;
}
export function addToTabSequence(parentNode, focusDay, focus = true) {
    let parentalNode = parentNode;
    if (!parentalNode && typeof window !== 'undefined')
        parentalNode = window.document;
    const buttons = collectCalendarButtons(parentalNode);
    function handleButton(button) {
        button.setAttribute('tabindex', '-1');
        const dateString = button.getAttribute('aria-label');
        if (dateString) {
            const day = new Date(String(dateString));
            if (isSameDay(day, focusDay)) {
                button.setAttribute('tabindex', '0');
                if (focus) {
                    button.focus();
                }
            }
        }
    }
    if (buttons) {
        buttons.forEach(handleButton);
    }
}
export function isOffsetControlled(propOffset) {
    return propOffset !== undefined;
}
export function getOffset(prop, state = 0) {
    if (prop) {
        return prop;
    }
    return state;
}
export function determineSelectedDates(selected) {
    if (Array.isArray(selected)) {
        return selected;
    }
    if (selected) {
        return [selected];
    }
    return [];
}
export function isValidDate(d) {
    return d instanceof Date && !Number.isNaN(d);
}
